import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import styles from '../Css/SubscriptionScreen3.module.css';

const SUBSCRIBE_URL = "https://bigcash.gameninja.in/?ani=nzLxEkKr0oMLljs2cZJeKg%3D%3D&gameId=1&serviceId=1";

const SubscriptionScreen3 = () => {
  const [phoneNumber, setPhoneNumber] = useState('');
  const [selectedPlan, setSelectedPlan] = useState(1);
  const [isFocused, setIsFocused] = useState(false);

  const today = new Date().toLocaleDateString('en-GB', { day: '2-digit', month: '2-digit', year: 'numeric' }).replace(/\//g, '-');

  const handleSubscribe = () => { window.location.href = SUBSCRIBE_URL; };

  const plans = [
    {
      id: 0, name: 'DAILY', tagline: 'Test the waters', price: '1.20', currency: 'GHC',
      period: '/day', color: '#C9A84C',
      features: ['1 Lucky Number Daily', 'SMS Notification', 'Daily Prize Pool'],
    },
    {
      id: 1, name: 'WEEKLY', tagline: 'Most rewarding', price: '5.00', currency: 'GHC',
      period: '/week', color: '#FFD700', featured: true,
      features: ['7 Lucky Numbers', 'Weekly Jackpot Entry', 'SMS + WhatsApp Alert', '2× Winning Chance'],
    },
    {
      id: 2, name: 'MONTHLY', tagline: 'Maximum power', price: '15.00', currency: 'GHC',
      period: '/month', color: '#FFF8DC',
      features: ['30 Lucky Numbers', 'Monthly Mega Jackpot', 'Priority Notifications', '4× Winning Chance', 'VIP Concierge'],
    },
  ];

  const winners = [
    '2332576xx999', '2335451xx399', '2335536xx699', '2332413xx299',
    '2335426xx499', '2335978xx499', '2335431xx999', '2335488xx999',
    '2332571xx111', '2335459xx222', '2335532xx333', '2332418xx444',
  ];

  const testimonials = [
    { name: 'Kwame A.', city: 'Accra', text: 'Won GHC 500 on my third day! Incredible platform.', stars: 5 },
    { name: 'Ama S.', city: 'Kumasi', text: 'Best decision I ever made. Winning daily now!', stars: 5 },
    { name: 'Kojo M.', city: 'Takoradi', text: 'Fast payouts, real numbers, real wins. Love it.', stars: 5 },
  ];

  return (
    <div className={styles.container}>
      {/* Royal texture overlays */}
      <div className={styles.noiseTexture}></div>
      <div className={styles.royalPattern}></div>

      {/* Background gradients */}
      <div className={styles.bgGradientTop}></div>
      <div className={styles.bgGradientBottom}></div>

      {/* Decorative borders */}
      <div className={styles.cornerTL}></div>
      <div className={styles.cornerTR}></div>
      <div className={styles.cornerBL}></div>
      <div className={styles.cornerBR}></div>

      {/* ---- Royal Navbar ---- */}
      <motion.nav
        initial={{ opacity: 0, y: -20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8, ease: [0.16, 1, 0.3, 1] }}
        className={styles.navbar}
      >
        <div className={styles.navLeft}>
          <img src="/assets/images/luckynumberlogo.png" alt="Lucky Number" className={styles.navLogo} />
        </div>
        <div className={styles.navLinks}>
          <Link to="/" className={styles.navLink}>Home</Link>
          <Link to="/faq" className={styles.navLink}>FAQ</Link>
          <Link to="/terms" className={styles.navLink}>Terms</Link>
          <Link to="/subscribe" className={styles.navLink}>Classic</Link>
          <Link to="/subscribe2" className={styles.navLink}>Neon</Link>
        </div>
        <button className={styles.navCta} onClick={handleSubscribe}>
          ♛ Join Elite
        </button>
      </motion.nav>

      {/* ---- Hero Section ---- */}
      <section className={styles.hero}>

        {/* 1. Crown + Tagline + Title + Subtitle */}
        <motion.div
          className={styles.heroCrown}
          initial={{ opacity: 0, scale: 0.5, rotate: -10 }}
          animate={{ opacity: 1, scale: 1, rotate: 0 }}
          transition={{ duration: 1, ease: [0.16, 1, 0.3, 1] }}
        >
          ♛
        </motion.div>

        <motion.div
          className={styles.heroTagline}
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.3, duration: 0.7 }}
        >
          <span className={styles.taglineLine}></span>
          ESTABLISHED IN EXCELLENCE
          <span className={styles.taglineLine}></span>
        </motion.div>

        <motion.h1
          className={styles.heroTitle}
          initial={{ opacity: 0, y: 40 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.45, duration: 0.9, ease: [0.16, 1, 0.3, 1] }}
        >
          The Royal
          <br />
          <span className={styles.heroTitleAccent}>Lucky Number</span>
          <br />
          Experience
        </motion.h1>

        <motion.p
          className={styles.heroSubtitle}
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.6, duration: 0.8 }}
        >
          Where fortune meets prestige. Ghana's most trusted lottery platform has paid out over
          <strong> GHC 2,000,000</strong> to our distinguished members.
        </motion.p>

        {/* 2. Plan Pack Selection — after text, before number card */}
        <motion.div
          className={styles.inlinePackSection}
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.65, duration: 0.8 }}
        >
          <div className={styles.inlinePackLabel}>
            <span className={styles.goldDividerLine}></span>
            <span className={styles.goldDividerText}>✦ CHOOSE YOUR PLAN ✦</span>
            <span className={styles.goldDividerLine}></span>
          </div>
          <div className={styles.inlinePlansGrid}>
            {plans.map((plan, i) => (
              <motion.div
                key={plan.id}
                className={`${styles.planCard} ${selectedPlan === plan.id ? styles.planCardActive : ''} ${plan.featured ? styles.planCardFeatured : ''}`}
                onClick={() => setSelectedPlan(plan.id)}
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ delay: 0.7 + i * 0.1, duration: 0.6 }}
                whileHover={{ y: -6 }}
              >
                {plan.featured && <div className={styles.planFeaturedBadge}>★ MOST POPULAR</div>}
                <div className={styles.planName}>{plan.name}</div>
                <div className={styles.planTagline}>{plan.tagline}</div>
                <div className={styles.planPriceRow}>
                  <span className={styles.planCurrency}>{plan.currency}</span>
                  <span className={styles.planPrice}>{plan.price}</span>
                  <span className={styles.planPeriod}>{plan.period}</span>
                </div>
                <div className={styles.planDivider}></div>
                <ul className={styles.planFeatures}>
                  {plan.features.map((f, fi) => (
                    <li key={fi} className={styles.planFeature}>
                      <span className={styles.planFeatureIcon}>✦</span>
                      {f}
                    </li>
                  ))}
                </ul>
                <button
                  className={`${styles.planBtn} ${selectedPlan === plan.id ? styles.planBtnActive : ''}`}
                  onClick={(e) => { e.stopPropagation(); handleSubscribe(); }}
                >
                  {selectedPlan === plan.id ? '♛ Selected — Subscribe' : 'Select Plan'}
                </button>
              </motion.div>
            ))}
          </div>
        </motion.div>

        {/* 3. Number Reveal Card */}
        <motion.div
          className={styles.numberReveal}
          initial={{ opacity: 0, scale: 0.9 }}
          animate={{ opacity: 1, scale: 1 }}
          transition={{ delay: 1.0, duration: 0.8 }}
        >
          <div className={styles.numberRevealHeader}>
            <div className={styles.ornament}>✦ ─────</div>
            <span>Today's Royal Number — {today}</span>
            <div className={styles.ornament}>───── ✦</div>
          </div>
          <div className={styles.royalNumbers}>
            {['X','X','X','X','X'].map((n,i) => (
              <div key={i} className={styles.royalNumBox}>{n}</div>
            ))}
            <div className={styles.royalNumSep}>·</div>
            {['8','8','5','9','9'].map((n,i) => (
              <div key={i} className={`${styles.royalNumBox} ${styles.royalNumBoxGold}`}>{n}</div>
            ))}
          </div>
          <p className={styles.numberRevealNote}>Subscribe to unlock your personal lucky number</p>
        </motion.div>

        {/* 4. Subscribe Form */}
        <motion.div
          className={styles.subscribeArea}
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 1.1, duration: 0.8 }}
        >
          <div className={`${styles.phoneWrapper} ${isFocused ? styles.phoneWrapperFocus : ''}`}>
            <div className={styles.phonePre}>🇬🇭</div>
            <input
              type="tel"
              className={styles.phoneInput}
              value={phoneNumber}
              onChange={e => setPhoneNumber(e.target.value)}
              placeholder="Your phone number"
              onFocus={() => setIsFocused(true)}
              onBlur={() => setIsFocused(false)}
            />
          </div>
          <button className={styles.subscribeBtn} onClick={handleSubscribe}>
            <span className={styles.btnShimmer}></span>
            ♛ SUBSCRIBE NOW
          </button>
        </motion.div>

      </section>

      {/* ---- Royal Stats ---- */}
      <motion.div
        className={styles.statsSection}
        initial={{ opacity: 0 }}
        whileInView={{ opacity: 1 }}
        viewport={{ once: true }}
        transition={{ duration: 0.8 }}
      >
        <div className={styles.statsInner}>
          {[
            { icon: '♛', num: '50,000+', label: 'Distinguished Members' },
            { icon: '◆', num: 'GHC 2M+', label: 'Total Prizes Paid' },
            { icon: '✦', num: '161', label: 'Winners Today' },
            { icon: '●', num: '3+ Years', label: 'Of Royal Excellence' },
          ].map((s, i) => (
            <motion.div
              key={i}
              className={styles.statItem}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: i * 0.1, duration: 0.6 }}
            >
              <div className={styles.statIcon}>{s.icon}</div>
              <div className={styles.statNum}>{s.num}</div>
              <div className={styles.statLabel}>{s.label}</div>
            </motion.div>
          ))}
        </div>
      </motion.div>

      {/* ---- Testimonials ---- */}
      <section className={styles.testimonialsSection}>
        <div className={styles.goldDivider}>
          <span className={styles.goldDividerLine}></span>
          <span className={styles.goldDividerText}>✦ MEMBER TESTIMONIALS ✦</span>
          <span className={styles.goldDividerLine}></span>
        </div>
        <div className={styles.testimonialsGrid}>
          {testimonials.map((t, i) => (
            <motion.div
              key={i}
              className={styles.testimonialCard}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: i * 0.12, duration: 0.7 }}
            >
              <div className={styles.testimonialQuote}>"</div>
              <p className={styles.testimonialText}>{t.text}</p>
              <div className={styles.testimonialStars}>{'★'.repeat(t.stars)}</div>
              <div className={styles.testimonialAuthor}>
                <strong>{t.name}</strong> · {t.city}
              </div>
            </motion.div>
          ))}
        </div>
      </section>

      {/* ---- Winners Scroll ---- */}
      <motion.section
        className={styles.winnersSection}
        initial={{ opacity: 0 }}
        whileInView={{ opacity: 1 }}
        viewport={{ once: true }}
        transition={{ duration: 0.8 }}
      >
        <div className={styles.goldDivider}>
          <span className={styles.goldDividerLine}></span>
          <span className={styles.goldDividerText}>✦ {today} WINNERS (161) ✦</span>
          <span className={styles.goldDividerLine}></span>
        </div>
        <div className={styles.winnersList}>
          {winners.map((w, i) => (
            <motion.div
              key={i}
              className={styles.winnerItem}
              initial={{ opacity: 0, x: -20 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: true }}
              transition={{ delay: i * 0.05, duration: 0.5 }}
            >
              <span className={styles.winnerRank}>#{String(i + 1).padStart(2, '0')}</span>
              <span className={styles.winnerNum}>{w}</span>
              <span className={styles.winnerSeal}>✦</span>
            </motion.div>
          ))}
        </div>
      </motion.section>

      {/* Footer */}
      <footer className={styles.footer}>
        <div className={styles.footerOrnament}>✦ ────────────── ✦ ────────────── ✦</div>
        <p className={styles.footerText}>
          Lucky Number is a fun, chance-based game where you pick a number, test your luck, and discover daily rewards.
          Participate daily to maximize your chances of winning big!
        </p>
        <div className={styles.footerLinks}>
          <Link to="/terms" className={styles.footerLink}>Terms & Conditions</Link>
          <span className={styles.footerDot}>·</span>
          <Link to="/faq" className={styles.footerLink}>FAQ</Link>
          <span className={styles.footerDot}>·</span>
          <Link to="/" className={styles.footerLink}>Home</Link>
        </div>
        <div className={styles.footerCopyright}>© 2024 Lucky Number. All rights reserved.</div>
      </footer>
    </div>
  );
};

export default SubscriptionScreen3;
